/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

import {ROOM_DAILY_SUMMARY_API} from './constants'
import type {
  GetRoomDailySummaryParams,
  RoomBonusState,
  RoomDailySummary,
} from './types'

type ApiEnvelope<T> = {
  ret: number
  data: T
}

const initialSummary: RoomDailySummary = {
  visible: false,
  room_id: 0,
  room_level: 0,
  today_amount: 0,
  today_estimate: 0,
  yesterday_amount: 0,
  yesterday_estimate: 0,
  yesterday_room_level: 0,
  level_rules: [],
  err_msg: '',
}

const initialState: RoomBonusState = {
  summary: initialSummary,
}

export const getRoomDailySummary = createAsyncThunk(
  'RoomBonus/getRoomDailySummary',
  async (arg: GetRoomDailySummaryParams, store: any) => {
    const resp = await http.post<ApiEnvelope<RoomDailySummary>>(
      ROOM_DAILY_SUMMARY_API,
      {
        ...store.getState().env.deviceinfo,
        room_id: arg.room_id,
      },
      {store, xcErrorToast: true}
    )
    return resp?.data?.data
  }
)

export const roomBonusSlice = createSlice({
  name: 'SaadaRoomBonus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRoomDailySummary.fulfilled, (state, action) => {
      Object.assign(state.summary, action.payload || {})
      state.summary.level_rules = action.payload?.level_rules || []
    })
  },
})

export default roomBonusSlice.reducer

export const useRoomBonusState = (): RoomBonusState =>
  useSelector((state: any) => state.SaadaRoomBonus as RoomBonusState) ??
  initialState
